import alt from 'epic-react-common/src/alt';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * NewsLetterActions
 */
export default generateWithAsyncActions(alt, [
    'getSubscriptionStatus',
    'signUpNewsLetter'
]);
